var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff2653;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.4,15.02222l.91111.84445a.51157.51157,0,0,0,.68889,0l.91111-.84445c4.46667-4.13333,7.42222-6.84444,7.42222-10.17777A4.75755,4.75755,0,0,0,12.55556,0,5.41342,5.41342,0,0,0,8.66667,2.04445,5.45975,5.45975,0,0,0,4.75555,0,4.75286,4.75286,0,0,0,0,4.84445C0,8.17778,2.95555,10.88889,7.4,15.02222Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFav);
export default __webpack_public_path__ + "static/media/ic_fav.d0af617e5e1c6b942cfa2538c0912c06.svg";
export { ForwardRef as ReactComponent };